import "./App.css";
import CardContainer from "./components/CardContainer";
import Header from "./components/Header";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <div className="App">
      <Header/>
      <CardContainer/>
      
    </div>
  );
}

export default App;
